<template>
  <div class="effects-control">
    <select 
      class="effects-select"
      :value="currentEffect || ''"
      @change="handleEffectChange"
    >
      <option value="">{{ t('ui.noEffect') }}</option>
      <option value="rain">🌧️ {{ t('ui.rain') }}</option>
      <option value="snow">❄️ {{ t('ui.snow') }}</option>
      <option value="stars">⭐ {{ t('ui.stars') }}</option>
    </select>
  </div>
</template>

<script>
import { useI18n } from '@/i18n'

export default {
  name: 'EffectsControl',
  props: {
    currentEffect: {
      type: String,
      default: null
    }
  },
  emits: ['toggleEffect'],
  setup() {
    const { t } = useI18n()
    
    return {
      t
    }
  },
  methods: {
    handleEffectChange(event) {
      const selectedEffect = event.target.value
      // 如果选择的是当前激活的特效，则取消特效
      if (selectedEffect === this.currentEffect) {
        this.$emit('toggleEffect', null)
      } else {
        this.$emit('toggleEffect', selectedEffect || null)
      }
    }
  }
}
</script>

<style scoped>
.effects-control {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 25;
}

.effects-select {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
  outline: none;
  min-width: 120px;
  appearance: none;
  padding-right: 40px;
}

.effects-control::after {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  pointer-events: none;
  opacity: 0.7;
}

.effects-select:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.4);
  color: white;
}

.effects-select:focus {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}

.effects-select option {
  background: rgba(30, 58, 138, 0.95);
  color: white;
  padding: 8px;
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .effects-control {
    top: 15px;
    right: 15px;
  }

  .effects-select {
    font-size: 0.85rem;
    padding: 10px 16px;
    padding-right: 36px;
    min-width: 110px;
  }
}

@media (max-width: 480px) {
  .effects-control {
    top: 12px;
    right: 12px;
  }

  .effects-select {
    font-size: 0.8rem;
    padding: 8px 14px;
    padding-right: 32px;
    min-width: 100px;
  }
}

/* iOS Safari选择框显示修复 - 边框+文字样式 */
@supports (-webkit-touch-callout: none) {
  .effects-select {
    background: transparent !important;
    border: 2px solid rgba(255, 255, 255, 0.6) !important;
    backdrop-filter: none !important;
    color: rgba(255, 255, 255, 0.8) !important;
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  
  .effects-select:hover {
    background: transparent !important;
    border-color: rgba(255, 255, 255, 0.9) !important;
    color: rgba(255, 255, 255, 1) !important;
  }
  
  .effects-select:focus {
    background: transparent !important;
    border-color: rgba(255, 255, 255, 1) !important;
    color: white !important;
    box-shadow: none !important;
  }
  
  .effects-control::after {
    stroke: rgba(255, 255, 255, 0.8) !important;
    opacity: 1 !important;
  }
}

/* iOS PWA 模式适配 - 下移位置避免被status bar遮挡 */
@supports (-webkit-touch-callout: none) {
  @media (display-mode: standalone) {
    .effects-control {
      top: calc(20px + env(safe-area-inset-top));
    }
    
    @media (max-width: 768px) {
      .effects-control {
        top: calc(20px + env(safe-area-inset-top));
      }
    }
    
    @media (max-width: 480px) {
      .effects-control {
        top: calc(20px + env(safe-area-inset-top));
      }
    }
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  .effects-control {
    top: 10px;
    right: 200px;
  }
}
</style>